"use strict";

import React from 'react';
import Row from'react-bootstrap/lib/Row';
import Col from'react-bootstrap/lib/Col';
import Button from'react-bootstrap/lib/Button';
import Joi from 'joi';
import Validation from 'react-validation-decorator/lib/Validation';

import FileUploader from '../../FileUploader';
import PlacesSearch from '../../Places-Search';

import { LiCreateUrl, LiUrlParser } from '../../../helpers';

import {AlertActions, FileActions} from '../../../actions';
import {FileStore} from '../../../stores';

const customJoi = Joi.extend((joi) => ({
  base: joi.string(),
  name: 'string',
  language: {
    has: 'is not valid'
  },
  rules: [
    {
      name: 'has',
      params: {
        text: Joi.string().required()
      },
      validate(params, value, state, options) {
        if (value.indexOf(params.text) === -1) {
          // Generate an error, state and options need to be passed
          return this.createError('string.has', {v: value}, state, options);
        }

        return value; // Everything is OK
      }
    }
  ]
}));


class OrganizationForm extends React.Component {
  constructor() {
    super();

    this.state = {
      name: '',
      logoUrl: '',
      liUrl: '',
      url: '',
      location: '',
      description: '',
      type: '',
      isActive: false,
      progress: null,
      website:''
    };

    this._handleFileStore = this._handleFileStore.bind(this);
    this._handleInputChange = this._handleInputChange.bind(this);
    this._handleLiUrlChange = this._handleLiUrlChange.bind(this);
    this._handleLocationChange = this._handleLocationChange.bind(this);
    this._isFormValid = this._isFormValid.bind(this);
    this._handleImageChange = this._handleImageChange.bind(this);
  };

  static propTypes = {
    model: React.PropTypes.object,
    actionButtons: React.PropTypes.bool.isRequired,
    onSubmit: React.PropTypes.func,
    onCancel: React.PropTypes.func
  };

  validationSchema = Joi.object().keys({
    name: Joi.string().required().label('Name'),
    website: Joi.string().required().label('website'),
    logoUrl: Joi.string().allow(['', null]).optional().label('Logo Url'),
    url: Joi.alternatives().try([
      customJoi.string().uri().has('/company-beta/'),
      customJoi.string().uri().has('/company/'),
      customJoi.string().uri().has('/school/'),
      customJoi.string().uri().has('/edu/school/')
    ]).label('Li Url'),
    location: Joi.string().allow('').optional().label('Location'),
    description: Joi.string().allow('').optional().label('Description'),
    type: Joi.string().allow(['School', 'Company']).label('Type'),
    isActive: Joi.boolean().optional().label('Active')
  });

  componentWillMount() {
    const {model} = this.props;

    if (model) {
      this.setState({
        name: model.name,
        logoUrl: model.logoUrl,
        url: LiCreateUrl(model.liId, model.type),
        website: model.website,
        location: model.location,
        description: model.description,
        type: model.type,
        isActive: model.isActive
      });
    }

    FileStore.listen(this._handleFileStore);
  };

  componentWillUnmount() {
    FileStore.unlisten(this._handleFileStore);
  };

  render() {
    const {actionButtons, onSubmit, onCancel} = this.props;
    const {name, logoUrl, website, url, location, description, type, isActive, progress, validation} = this.state;

    return (
      <form name="orgFrm" noValidate>
        <Row>
          <Col md={12}>
            <div className={ this.getValidationClassName('name') }>
              <label>Name</label>
              <input type='text' className='form-control'
                     value={ name }
                     placeholder="Enter Name..."
                     onChange={ this._handleInputChange.bind(this, 'name') }/>
              { this.renderValidationMessages('name') }
            </div>
          </Col>
        </Row>
        <Row style={{ marginBottom: 20 }}>
          <Col md={6}>
            <div className={ this.getValidationClassName('logo') }>
              <label>Logo</label>
              <input type='text' className='form-control'
                      value={ logoUrl }
                      disabled="true"
                      placeholder="Upload logo..."/>
            </div>
          </Col>
          <Col md={6}>
            <div className={ "school-img university " + this.getValidationClassName('small') }>
              <FileUploader size="small" src={ logoUrl } onChange={ this._handleImageChange }
                            progress={ progress }/>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className={ this.getValidationClassName('url') }>
              <label>Url</label>
              <input type='text' className='form-control'
                      value={ website }
                      placeholder="Enter Organization Url..."
                      onChange={ this._handleInputChange.bind(this, 'website') }/>
              { this.renderValidationMessages('website') }
            </div>
          </Col>
          <Col md={6}>
            <div className={ this.getValidationClassName('url') }>
              <label>Li Url</label>
              <input type='text' className='form-control'
                      value={ url }
                      placeholder="Enter Li Url..."
                      onChange={ this._handleLiUrlChange }/>
              { this.renderValidationMessages('url') }
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className={ this.getValidationClassName('location') }>
              <label>Location</label>
              <PlacesSearch type="text" value={ location } onSelection={ this._handleLocationChange }/>
              { this.renderValidationMessages('location') }
            </div>
          </Col>
          <Col md={6}>
            <div className={ this.getValidationClassName('type') }>
              <label>Organization Type</label>
              <select className='form-control'
                      value={ type }
                      onChange={this._handleInputChange.bind(this, 'type')}>
                <option key='0' value={ '' }>Select</option>
                <option key='1' value={ 'school' }>School</option>
                <option key='2' value={ 'company' }>Company</option>
              </select>
              { this.renderValidationMessages('type') }
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className={ this.getValidationClassName('description') }>
              <label>Description</label>
              <textarea rows="5" className='form-control'
                        value={ description }
                        placeholder="Enter Organization Description..."
                        onChange={ this._handleInputChange.bind(this, 'description') }/>
              { this.renderValidationMessages('description') }
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <div className={ this.getValidationClassName('active') }>
              <input className="m-r-10" type="checkbox" checked={ isActive }
                    onChange={ this._handleActiveChange.bind(this, 'isActive') }/>
              <label className="m-l-5p">Active Organization</label>
            </div>
          </Col>
          {
            actionButtons ?
              <Col md={4} className="pull-right">
                <Button type="submit" bsStyle="success" disabled={ !!validation.errors.length }
                        onClick={ onSubmit && onSubmit.bind(this)}>Submit</Button>
                <Button className="m-l-5p" bsStyle="default" onClick={ onCancel && onCancel.bind(this) }>Cancel</Button>
              </Col> :
              null
          }
        </Row>
      </form>
    )
  };

  _handleFileStore(state) {
    if (state._fileProgress) {
      this.setState({progress: state._fileProgress});
    }

    if (state._fileCdn) {
      this.setState({progress: null}, () => {
        this.setState({logoUrl: state._fileCdn}, () => {
          this.validate('logoUrl');
          this._isFormValid();
        });
        FileStore.cleanup();
        // setTimeout for firing action in next event loop
        setTimeout(() => {
          AlertActions.success({message: "Logo uploaded successfully!"})
        }, 0);
      });
    }
  };

  _handleInputChange(formInput, event) {
    const value = event.target.value;
    this.setState(state => {
      state[formInput] = value;
    }, () => {
      this.validate(formInput);
      this._isFormValid();
    });
  };

  _handleLiUrlChange(e) {
    const value = e.target.value;
    const liParams = LiUrlParser(value);

    this.setState({
      url: value,
      type: liParams ? liParams.type : ''
    }, () => {
      this.validate('url');
      this.validate('type');
      this._isFormValid();
    });
  };

  _handleLocationChange(value) {
    this.setState({location: value}, () => {
      this.validate('location');
      this._isFormValid();
    });
  };

  _handleActiveChange(formInput, event) {
    let value = event.target.checked;
    this.setState(state => {
      state[formInput] = value;
    }, () => {
      this.validate(formInput);
      this._isFormValid();
    });
  }

  _isFormValid() {
    const {isValid} = this.props;
    const {validation} = this.state;

    if (isValid && typeof isValid === 'function') {
      isValid(!validation.errors.length);
    }
  };

  getModel() {
    const {name, logoUrl, website, url, location, description, type, isActive, file} = this.state;
    return {
      name,
      logoUrl,
      website,
      url,
      location,
      description,
      type: type,
      isActive: isActive,
      file
    };
  };

  _handleImageChange(file) {
    console.log("here -> ", this.props.model)
    this.setState({file});
    // FileActions.uploadFile(file, { org: this.props.model._id });
  };

  reset() {
    this.resetValidation(() => {
      this.setState({});
    });
  };
}

export default Validation(OrganizationForm);
